import {
  CreateDocumentType,
  Document,
  DocumentType,
  UploadDocument,
} from '@/types';
import {
  Core,
  DOCUMENT_MANAGEMENT_DOCUMENT_TYPES,
  DOCUMENT_MANAGEMENT_DOCUMENTS,
  DOCUMENT_MANAGEMENT_DOCUMENT_TYPE,
  DOCUMENT_MANAGEMENT_DOCUMENT,
} from '@/api/Core';

class DocumentManagement extends Core {
  /** Document Types: */
  getDocumentTypes = async () =>
    this.get<DocumentType[]>(DOCUMENT_MANAGEMENT_DOCUMENT_TYPES());

  createDocumentType = async (data: CreateDocumentType) =>
    this.post(DOCUMENT_MANAGEMENT_DOCUMENT_TYPES(), data);

  deleteDocumentType = async (documentTypeId: number) =>
    this.delete(DOCUMENT_MANAGEMENT_DOCUMENT_TYPE(documentTypeId));

  /** Documents: */
  getDocuments = async () =>
    this.get<Document[]>(DOCUMENT_MANAGEMENT_DOCUMENTS());

  uploadDocument = async (data: UploadDocument) =>
    this.post(DOCUMENT_MANAGEMENT_DOCUMENTS(), data);

  deleteDocument = async (documentId: number) =>
    this.delete(DOCUMENT_MANAGEMENT_DOCUMENT(documentId));
}

export const documentManagement = new DocumentManagement();
